/* eslint-disable postro4no/object-props */
export const playersModalParams = [
  {
    checked: true, id: 0, key: 'Index', label: 'Index',
  },
  {
    checked: true, id: 1, key: 'Goals scored', label: 'Goals',
  },
  {
    checked: true, id: 2, key: 'Chances, %', label: 'Chances, %',
  },
  {
    checked: true, id: 3, key: 'Fouls', label: 'Fouls',
  },
  {
    checked: true, id: 4, key: 'Yellow cards', label: 'Yellow cards',
  },
  {
    checked: true, id: 5, key: 'Red cards', label: 'Red cards',
  },
  {
    checked: true, id: 6, key: 'Tactics - Match start', label: 'Tactics - Match start',
  },
  {
    checked: true, id: 7, key: 'Offsides', label: 'Offsides',
  },
  {
    checked: true, id: 8, key: 'Corners', label: 'Corners',
  },
  {
    checked: true, id: 9, key: 'Shots', label: 'Shots',
  },
  {
    checked: true, id: 10, key: 'Shots on target', label: 'Shots on target',
  },
  {
    checked: true, id: 11, key: 'Passes', label: 'Passes',
  },
  {
    checked: true, id: 12, key: 'Passes accurate, %', label: 'Passes accurate, %',
  },
]
